function checkout()
{
    jQuery(function($) {
        /**
         * Hide or show '-' and '+' buttons besides quantity input.
         */
        const hideOrShowQuantityCtrl = function($input) {
            let $minus = $input.closest('.product-quantity').find('.quantity-ctrl.minus');
            let $plus = $input.closest('.product-quantity').find('.quantity-ctrl.plus');
            let val = parseInt($input.val());
            let min = parseInt($input.attr('min') || 1);
            let max = parseInt($input.attr('max') || -1);

            if (val <= min) {
                $minus.addClass('disabled');
            }
            else {
                $minus.removeClass('disabled');
            }

            if (max !== -1 && val >= max) {
                $plus.addClass('disabled');
            }
            else {
                $plus.removeClass('disabled');
            }
        }

        $('.woocommerce-cart-form .product-quantity .quantity input').each(function(index) {
            hideOrShowQuantityCtrl($(this));
        });

        if ($('.woocommerce-cart-form .product-quantity .quantity input')) {
            $('body').on('updated_cart_totals', function () {
                $('.woocommerce-cart-form .product-quantity .quantity input').each(function (index) {
                    hideOrShowQuantityCtrl($(this));
                });
            })
        }

        $('body').on('click', '.woocommerce-cart-form .product-remove .remove', function(e) {
            var confirm_remove_product = $('#confirm_remove_product').text();

            return confirm(confirm_remove_product);
        });

        $('body').on('submit', '.woocommerce-cart-form', function(e) {
            var display_alert = false;

            $('.woocommerce-cart-form .product-quantity .quantity input').each(function(e) {
                if (parseInt($(this).val()) <= 0) {
                    display_alert = true;
                }
            });

            if (display_alert) {
                var confirm_remove_product = $('#confirm_remove_product').text();

                return confirm(confirm_remove_product);
            }

            return true;
        });

        $('body').on('change', '.woocommerce-cart-form .product-quantity .quantity input', function() {
            $('.woocommerce-cart-form button[name="update_cart"]').trigger('click');
        });

        $('body').on('click', '.quantity-ctrl', function() {
            let $input = $(this).closest('.product-quantity').find('input');
            let step = parseInt($input.attr('step') || 1);

            if ($(this).hasClass('minus')) {
                $input.val(+ $input.val() - step);
            } else {
                $input.val(+ $input.val() + step);
            }

            $input.trigger('change');
            $input.trigger('change');

            hideOrShowQuantityCtrl($input);
        });

        //Deploy new address form
        $('.woocommerce-checkout .mtn-form-new-address').hide();

        $('.woocommerce-checkout').on('click', '.add-new-address', function(e) {
            e.stopPropagation();
            $('.mtn-form-new-address').slideToggle();
        });

        // Show all cart button.
        let allProductShown = $('.cart_item.show_all_cart').hasClass('opened');

        $('.woocommerce-checkout').on('click', '.cart_item.show_all_cart', function (e) {
            e.stopPropagation();
            e.preventDefault();

            if (allProductShown) {
                $('.cart_item:not(.show_all_cart)').each(function (index) {
                    if (index > 3) {
                        $(this).addClass('hidden');
                    }
                });
                $('.cart_item.show_all_cart').removeClass('opened');
            }
            else {
                $('.cart_item.hidden').removeClass('hidden');
                $('.cart_item.show_all_cart').addClass('opened');
            }

            allProductShown = $('.cart_item.show_all_cart').hasClass('opened');
        });

        $(document.body).on('updated_checkout', function (e) {
            if (allProductShown) {
                $('.cart_item.hidden').removeClass('hidden');
                $('.cart_item.show_all_cart').addClass('opened');
            }
        });

        // Handle popups.
        $('.popup-opener').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $($(e.target).data('popup')).show();
        });

        $('.checkout-popup__close').on('click', function (e) {
            $(e.target).closest('.checkout-popup').hide();
        })

        // Handle mantion shipping mode change.
        function handle_mantion_shipping_mode_choice(input) {
            $('.mantion-shipping-mode').removeClass('active');

            if (input) {
                let container = input.closest('.mantion-shipping-mode');

                container.addClass('active');
                $('.carrier-choices').prependTo(container.find('.carrier-holder'));

                // If relay mantion, hide some carriers and pre-select the choosen one if necessary.
                // Note : If Mantion did their job correctly, we should have either 3 DPD choices
                // or exactly 1 JEANTET choice, always.
                if (input.val() === 'relay_mantion') {
                    let check = $('input.shipping_method')[0];

                    if (check && ['dpdfrance_relais', 'dpdfrance_predict', 'dpdfrance_classic'].includes($(check).val())) {
                        $('input.shipping_method').each((i, el) => {
                            if ($(el).val() !== 'dpdfrance_classic') {
                                $(el).closest('li.carrier').hide();
                            }
                            else {
                                $(el).click();
                            }
                        });
                    }
                }
                else {
                    $('li.carrier').show();
                }
            }
        }

        $('input[name="mantion_shipping_mode"]').on('change', function (el) {
            handle_mantion_shipping_mode_choice($(el.target));
        });

        handle_mantion_shipping_mode_choice($('input[name="mantion_shipping_mode:selected"]'));
    });
}

export { checkout };
